import httpV2 from '@/utils/httpV2';

const state = {

};
const getters = {};

const mutations = {};

const actions = {
    //分页获取搜索列表
    getSearchRecordPage({ state, commit }, params) {
        let promise = httpV2.get2("/b2c/v1.0/mgr/searchRecord/page", params, this);
        return promise;
    },

    //分页获取搜索列表
    exportSearchRecord({ state, commit }, params) {
        let promise = httpV2.getFile("/b2c/v1.0/mgr/searchRecord/export", params, this);
        return promise;
    },

};

export default {
    getters,
    state,
    mutations,
    actions
};
